<template>
  <el-dialog :title="title" v-model="isShow" :modal="true" width="99%" top="1vh" @open="openedDialog" @close="closeDialog">
    <video 
      controls 
      autoplay 
      style="width: 100%; height: calc(100vh - 190px);" 
      ref="videoRef"
      v-on:fullscreenchange="onFullscreenchange"
      v-on:webkitfullscreenchange="onFullscreenchange"
    >
      <source :src="this.getFileSource(this.item.atta_url)" type="video/mp4">
    </video>
  </el-dialog>
</template>

<script>
module.exports = {
  name: "moreAttachment",
  props: {
    title: {
      type: String,
      default: () => {
        return '附件列表'
      }
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isShow: true,
      fit: "contain",
      heights:500,
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 根据浏览器高度设置初始高度
      this.heights = window.innerHeight - 660
      // 监听浏览器高度变化，修改表格高度
      window.onresize = () => {
        this.heights = window.innerHeight - 666
      }
    })
  },
  methods: {
    onFullscreenchange(){

    },
    getFileSource(url){
      return window.baseURL + url
    },
    openedDialog() {
      this.$nextTick(() => {
        
      })
    },
    closeDialog() {
      this.videoSource = ''
      this.$emit('close_dialog')
    }
  },
  watch:{
  }
};
</script>

<style>


</style>